export const showcaseSkills = [
  {
    label: "Javascript",
    rating: 71,
  },
  {
    label: "Node JS",
    rating: 81,
  },
  {
    label: "React",
    rating: 76,
  },
  {
    label: "Mongo dB",
    rating: 72,
  },
  {
    label: "Redux",
    rating: 73,
  },
  {
    label: "Express",
    rating: 74,
  },
  {
    label: "HTML CSS",
    rating: 85,
  },
];

export const frontSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },
  {
    label: "Material UI",
    src: "https://material-ui.com/static/logo_raw.svg",
  },
  {
    label: "Bootstrap",
    src: "https://i.ibb.co/zx0Tt9M/bootstrap.png",
  },
  {
    label: "Github",
    src: "https://img.icons8.com/fluent/480/000000/github.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
  {
    label: "Yarn",
    src: "https://i.ibb.co/GtbG98V/yarn2.png",
  },
];

export const backSkillsList = [
  {
    label: "Node JS",
    src: "https://img.icons8.com/color/480/000000/nodejs.png",
  },
  {
    label: "Express JS",
    src: "https://i.ibb.co/9smDM6j/pngegg.png",
  },
  {
    label: "Mongo dB",
    src: "https://i.ibb.co/ZVh01dm/rsz-mong2.png",
  },
  {
    label: "My Sql",
    src: "https://img.icons8.com/fluent/480/000000/mysql-logo.png",
  },
  {
    label: "Firebase",
    src: "https://img.icons8.com/color/480/000000/firebase.png",
  },
  {
    label: "Redis",
    src: "https://img.icons8.com/color/480/000000/redis.png",
  },
];

export const projectsList = [
  {
    label: "Coursera Clone",
    imgSrc: "images/coursera.png",
    src: "https://coursera-clone.netlify.app/",
    githubSrc: "https://github.com/vedascript/coursera-clone/tree/master",
    description:
      "An EdTech Platform with all MVP features.Student can enroll in their choice of course.Student can take snapshots and notes from lectures",
    stack: ["React", "Redux", "Express", "Mongoose", "Node.js", "Material-UI"],
  },
  {
    label: "Social Media Prototype",
    imgSrc: "images/social.png",
    src: "https://socialmedia-mern.netlify.app/",
    githubSrc: "https://github.com/vedascript/socialMedia-Mern",
    description:
      "A Social Media prototype where user perform CRUD operation on their posts.User can Like other's posts ",
    stack: [
      "React",
      "Redux",
      "Google-Auth",
      "Express",
      "Mongoose",
      "Node.js",
      "CSS",
    ],
  },
  {
    label: "Naukri Clone",
    imgSrc: "images/naukri.png",
    src: "https://naukri-clone.netlify.app/",
    githubSrc: "https://github.com/vedascript/naukri-clone",
    description:
      "A working clone of Naukri.com , It helps users in job search and selection.",
    stack: ["React", "Redux", "Firebase", "CSS"],
  },
  {
    label: "Expense Tracker",
    imgSrc: "images/expenses.png",
    src: "https://expenssetrackerr.netlify.app/",
    githubSrc: "https://github.com/vedascript/expenseTracker",
    description: "An expense tracker to track user's expenses",
    stack: ["React", "React-Charts", "Material-UI"],
  },
  {
    label: "Sudoku Solver",
    imgSrc: "images/sudoku.png",
    src: "https://sudokusolvervw.netlify.app",
    githubSrc: "https://github.com/vedascript/sudokuSolver",
    description: "A automated sudoku solver - an application of backtraking",
    stack: ["JavaScript", "HTML", "CSS"],
  },
  {
    label: "Fathom Health Clone",
    imgSrc: "images/fathom.png",
    src: "https://fathomhealth.netlify.app",
    githubSrc: "https://github.com/vedascript/fathomhealth-clone",
    description: "A visual clone of Fathom Health completed in 3 days",
    stack: ["JavaScript", "HTML", "CSS"],
  },
];
